module.exports = __webpack_public_path__ + "startpage-746fed5a/kuendigung-fe6ef5b738e1ee280f14fd2919dee60a.jpeg";